
import { useGameDetails } from 'utils/Hooks';

export function FormattedPrice(props) {
  const gameDetails = useGameDetails();

  function PriceStartsWithZero() {
    return (
      props.price.toString().slice(0,2) == '0.' ||
      props.price.toString().slice(0,3) == '-0.' ||
      props.price == 0
    );
  }

  if (props.price === undefined)
    return 'no price given to format'
  else if (props.price === null)
    return null;
  else {
    // console.log({
    //  price: props.price.toString(),
    //  sliced: props.price.toString().slice(0,2),
    // });
    if (PriceStartsWithZero())
      return Number(props.price).toFixed(gameDetails.priceDecimals);
    else
      return Number(props.price).toFixed(gameDetails.priceDecimals).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
}
